import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getAllTestProviders(_obj, params) {
    const res = await axios.get(`api/exam-results/test-providers/`, { params });
    return res.data;
  },

  async getTestProvider(_obj, id) {
    const res = await axios.get(`api/exam-results/test-providers/${id}/`);
    return res.data;
  },

  async createTestProvider(_obj, data) {
    const res = await axios.post(`api/exam-results/test-providers/`, data);
    return res.data;
  },

  async updateTestProvider(_obj, { id, data }) {
    return axios.patch(`api/exam-results/test-providers/${id}/`, data);
  },

  async deleteTestProvider(_obj, id) {
    return axios.delete(`api/exam-results/test-providers/${id}/`);
  },
};

export const testProvider = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
